/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import fetchHelper from "../services/fetchHelper";

const defaultStructure = {};

export const fetchAppConfigToggles = async () => {
  try {
    const response = await fetchHelper.get({
      url: "/patientmanagement/rest/feature-toggles",
    });

    return response;
  } catch (err) {
    console.log(err);

    return defaultStructure;
  }
};
